import styles from "./BlogList.module.css"
import Footer from "../../Footer/Footer"
import LoadingScreen from "../components/LoadingScreen";
import { useState, useEffect } from "react";
import headerImg from "../images/bloggen.jpg"
import defaultImg from "../images/bloggen.jpg"

export default function BlogList(){

    const API_BASE =
        process.env.NODE_ENV === "development"
          ? "http://localhost:3000"
          : "https://api.hillerodfrimenighed.dk";
    
      const [blogs, setBlogs] = useState(null);
      const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadBlogs(){
            try{
                const res = await fetch(`${API_BASE}/blog/`, {
                    headers: { "Content-Type": "application/json" },
                  });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                console.log(data)
                setBlogs(data);
            } catch (e) {
                console.log(e.message || "Kunne ikke hente blogindlæg");
            } finally {
                setLoading(false);
            }
        }
        loadBlogs();
    }, [])

    function formatDate(ts) {
        const d = new Date(ts); // works for "YYYY-MM-DD HH:mm:ss" or ISO
        if (isNaN(d)) return null;
        return d.toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" });
      };

    if (loading) return <LoadingScreen/>
    return(
        <>
            <div className={styles.section}>
                <div className={styles.header}>
                    <div className={styles.pageHeadImg} style={{backgroundImage:`url(${headerImg})`}}/>
                    <h1>BLOGGEN</h1>
                </div>
                {blogs.length === 0 ? (
                <p>Ingen blogindlæg endnu.</p>
                ) : (
                <ul className={styles.grid}>
                    {blogs.map((b) => (
                    <li key={b.blog_id} className={styles.card}>
                        <a href={`/bloggen/${b.blog_id}`} className={styles.cardLink} aria-label={`Læs: ${b.title}`}>
                        <div className={styles.thumb}>
                            {b.blog_image ? (
                            <img
                                src={b.blog_image}
                                alt={b.title || "Blogbillede"}
                                loading="lazy"
                            />
                            ) : (
                            <img
                                src={defaultImg}
                                alt={b.title || "Blogbillede"}
                                loading="lazy"
                            />
                            )}
                        </div>

                        <div className={styles.meta}>
                            <p className={styles.date}>{formatDate(b.blog_created_at)}</p>
                            <h3 className={styles.title}>{b.title}</h3>
                            {b.author_name && <p className={styles.author}>Af {b.author_name}</p>}
                        </div>
                        </a>
                    </li>
                    ))}
                </ul>
                )}
            </div>
            <Footer/>
        </>
    );
}